module.exports = __webpack_public_path__ + "img/appAsset--customer-econ-ax.c8f3374b.svg";